import cn from "classnames";

type Props = {
  listBarClassName?: string;
};

export const HorizontalScrollBar = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className="w-full overflow-x-auto whitespace-nowrap">
      <div
        className={cn(
          "flex h-fit w-fit min-w-full flex-row items-center justify-center gap-[12px]",
          props.listBarClassName,
        )}
      >
        {props.children}
      </div>
    </div>
  );
};
